import {
    Alert,
    Button,
    Card,
    CardContent,
    CardHeader,
    Grid,
    IconButton,
} from "@mui/material";
import React from "react";
import { Link, useLoaderData, useNavigate } from "react-router-dom";

import SyncIcon from "@mui/icons-material/Sync";

import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import EnhancedTable from "../../../../components/shared/table";

const DISTRIBUTION_COMPANIES_PATH = "/SLN/Management/DistributionCompanies";

const CompanyInformationPage = () => {
  const companyInfoList = useLoaderData("root");
  let navigate = useNavigate();
  const headCells = [
    {
      id: "updateOn",
      label: "تاریخ بروزرسانی",
      type: "date",
    },
    {
      id: "companyName",
      disablePadding: false,
      label: "شرکت",
    },
    {
      id: "state",
      disablePadding: false,
      label: "استان",
    },
    {
      id: "address",
      disablePadding: false,
      label: "آدرس",
    },
    {
      id: "isActive",
      type: "boolean",
      disablePadding: false,
      label: "وضعیت",
    },
  ];

  const onFetchData = () => {
    navigate();
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Alert
          severity="info"
          action={
            <Button
              component={Link}
              to={DISTRIBUTION_COMPANIES_PATH}
              color="inherit"
              size="small"
            >
              شرکت‌های توزیع
            </Button>
          }
        >
          این فهرست با «مدیریت ← شرکت‌های توزیع» یکی است و خودکار همگام می‌شود؛ ایجاد،
          ویرایش و حذف شرکت فقط از همان صفحه انجام شود.
        </Alert>
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title="شرکت"
            action={
              <IconButton
                variant="text"
                color="primary"
                onClick={onFetchData}
              >
                <SyncIcon />
              </IconButton>
            }
          />

          <CardContent>
            <Grid container>
              <Grid item xs={12} md={12}>
                <EnhancedTable
                  rowKey={"id"}
                  rows={companyInfoList}
                  headCells={headCells}
                  pageSize={100}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default CompanyInformationPage;
